import { Outlet, Navigate, useLocation } from 'react-router';
import { observer } from 'mobx-react-lite';
import { useStore } from '@link/triplabo/stores';

const PrivateRoute = () => {
  const { auth } = useStore();
  const location = useLocation();
  const isLoggedIn = auth.loggedIn;
  if (isLoggedIn) {
    return <Outlet />;
  } else {
    // save full path for redirect after login
    const fullPath = location.pathname + location.search;
    return <Navigate to="login" state={{ from: fullPath }} replace />;
  }
};

const ObserverPrivateRoute = observer(PrivateRoute);

export default ObserverPrivateRoute;
